import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import type { IProps as CleaveInputProps } from './CleaveInput';
import CleaveInput from './CleaveInput';

interface IProps extends CleaveInputProps {
  hasPermissions: Boolean;
  partial?: Boolean;
  viewingLevel?: string;
}

export default function PIIInput({
  changeHandler,
  fieldKey,
  fieldName,
  formData,
  hasPermissions,
  helperText = '',
  partial = false,
  viewingLevel = 'readonly',
  cleaveOptions: options,
}: IProps) {
  let fieldValue = get(formData, fieldKey, null);

  if (hasPermissions && partial && fieldValue !== null) {
    fieldValue = (
      fieldName === 'document_ssn'
        ? `XXXXX${fieldValue.slice(5)}`
        : fieldValue
    );
  } else if (!hasPermissions && fieldValue !== null) {
    fieldValue = 'XXXX';

    if (fieldName === 'document_ssn') {
      fieldValue = 'XXXXXXXXX';
    }

    if (fieldName === 'birth_date') {
      fieldValue = 'XXXX-XX-XX';
      // We need to set date false here otherwise our "mask" will not show up
      // since Cleave.js does not expect X's in-place of numbers for a date
      options.date = false;
    }
  }

  return (
    <CleaveInput
      changeHandler={changeHandler}
      cleaveOptions={options}
      extraOptions={(
        !isEmpty(viewingLevel)
          ? { className: viewingLevel, readOnly: viewingLevel }
          : undefined
      )}
      fieldKey={fieldKey}
      fieldName={fieldName}
      fieldValue={fieldValue}
      formData={formData}
      helperText={helperText}
    />
  );
}
